var map = {
	"./icon_Android.svg": 288,
	"./icon_Mac.png": 289,
	"./icon_QR.svg": 290,
	"./icon_Windows.png": 291,
	"./icon_download.svg": 184,
	"./icon_download_QR.jpg": 185,
	"./icon_iOS.svg": 292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 183;